module.exports = __webpack_public_path__ + "static/media/front.46959d9d.jpg";